import { Typography } from "@mui/material";
import { GoAlert } from "react-icons/go";

import { ERole } from "../../../../../@types";
import { apis, callApi } from "../../../../../api";
import { useAccount } from "../../../../../hooks/useAccount";
import { useStripe } from "../../../../../hooks/useStripe";
import { eventNames, logEvent } from "../../../../../utils/logEvent";

export function Earnings() {
	const { account } = useAccount();
	const { stripeData } = useStripe();

	if (!account || account.role !== ERole.INSTRUCTOR) {
		return null;
	}

	const onClickOpenStripe = async () => {
		try {
			const response = await callApi({
				method: "GET",
				url: apis.GET_LOGIN_LINK,
			});

			if (response?.loginLink?.url) {
				logEvent(eventNames.manageFinances);

				window.open(response.loginLink.url, "blank");
			}
		} catch (error) {}
	};

	const onClickCreateStripeAccount = async () => {
		try {
			const response = await callApi({
				method: "POST",
				url: apis.GET_ONBOARD_LINK,
			});

			if (response?.accountLink?.url) {
				localStorage.setItem("nextRoute", "/payments");
				window.location.href = response.accountLink.url;
			}
		} catch (error) {}
	};

	const isFinishedStripe =
		!account.requiredKYC && stripeData?.status === "ACTIVE";

	return (
		<>
			<Typography className="small-title-text bold">Earnings</Typography>
			<Typography className="normal-text item-separator-tiny">
				Set up or update automatic bank deposits, and easily track your
				earnings.
			</Typography>
			{!isFinishedStripe && (
				<div
					style={{ display: "flex", alignItems: "center", gap: "8px" }}
					className="item-separator-tiny">
					<div>
						<GoAlert className="normal-icon warning-icon" />
					</div>
					<Typography className="normal-text">
						Action Needed: Set up Stripe
					</Typography>
				</div>
			)}
			{isFinishedStripe && (
				<Typography
					className="normal-text bold payments-button item-separator-small"
					onClick={onClickOpenStripe}>
					Access Earnings Summary
				</Typography>
			)}

			{!isFinishedStripe && (
				<Typography
					className="normal-text payments-button item-separator-small"
					onClick={onClickCreateStripeAccount}>
					Create Stripe account
				</Typography>
			)}
			<div className="section-separator" />
		</>
	);
}
